var currentPage = "design";
$j = jQuery.noConflict();
//Object containing data generated by getProofImages.
var approveData = null;
//Object containing data generated by finishProductDesign.
var renderData = null;
//Object containing data generated by saveProduct.
var saveData = null;
//current state Id.
var currentStateId = "";
var previewImage = "";
var imageMaxHeight = 500;
var option_id = 0;
var option_value_id = 0;
let product = null;
let mockupPreviewsImages = [];
var configJson = window.configJson || {};
let is1color = false;

// Correspondance papiers → couleurs pour les mockups
const PAPER_COLORS = {
  "300BK": "#1A1A1A", // Noir (papier noir pour impression encre blanche)
  "300KT": "#D4A76A", // Kraft
  "350M": "#F5F5F5", // Mat
  "350M-PB": "#FAFAFA", // Mat Pelliculage Brillant
  "400M": "#F0F0F0", // Mat 400g
  "400M-PB": "#F8F8F8", // Mat 400g Pelliculage Brillant
};

// Correspondance textures foil → couleurs pour les previews
const FOIL_COLORS = {
  "FOIL01.jpg": "rgb(218, 165, 32)", // Or / Gold
  FOIL01: "rgb(218, 165, 32)",
  "FOIL02.jpg": "rgb(192, 192, 192)", // Argent / Silver
  FOIL02: "rgb(192, 192, 192)",
  "FOIL03.jpg": "rgb(184, 115, 51)", // Cuivre / Copper/Rose Gold
  FOIL03: "rgb(184, 115, 51)",
};

// Get foil color based on current texture
function getFoilColorGlobal() {
  if (!CONFIGURATOR || !CONFIGURATOR.ref_texture) {
    return "rgb(218, 165, 32)"; // Default to gold
  }
  return FOIL_COLORS[CONFIGURATOR.ref_texture] || "rgb(218, 165, 32)";
}

// check url params if has data property
const urlParams = new URLSearchParams(window.location.search);
// &data= is base64: read it raw (window.getUrlParamRaw, layout/theme.liquid),
// never through URLSearchParams, which turns its "+" into spaces.
const data = getUrlParamRaw("data");
const ref_configuration = urlParams.get("ref_id");

// if data property exists, set cookie with data
configJson = Object.assign({}, metafields_products, window.configJson || {});
window.configJson = configJson;

// get cookie ref_id
let CONFIGURATOR = getUrlConfig();

if (!CONFIGURATOR) {
  CONFIGURATOR = {};
  const _initProfil = urlParams.get("ref_profil");
  const _initProfilGroup = _initProfil
    ? document.querySelector(`[data-profil="${_initProfil}"]`)
    : null;
  CONFIGURATOR.current_paper = (
    _initProfilGroup?.querySelector("[data-paper-title].actif") ||
    document.querySelector("[data-paper-title].actif")
  )?.dataset.value;
  CONFIGURATOR.current_enveloppe = document.querySelector(
    "[data-enveloppe-title].actif",
  )?.dataset.value;

  CONFIGURATOR.current_ribbon = document.querySelector(
    "[data-ruban-title].actif",
  )?.dataset.value;

  CONFIGURATOR.quantity = 1;
  let profil = urlParams.get("ref_profil");

  CONFIGURATOR.format_imposition = configurator.format_imposition;
  CONFIGURATOR.ref_profil = profil;
}

// Sync current_paper to configJson if it exists in CONFIGURATOR
if (CONFIGURATOR && CONFIGURATOR.current_paper) {
  configJson.current_paper = window.configJson.current_paper =
    CONFIGURATOR.current_paper;
  console.log(
    `📄 Papier initialisé depuis CONFIGURATOR: ${CONFIGURATOR.current_paper}`,
  );
}

// Read cookie selections ONLY if no &data= in URL (URL data has priority)
// Also validate that the cookie belongs to the same product
const hasUrlData = data;
if (!hasUrlData) {
  const configuratorSelections = getCookie("configurator_selections");
  if (configuratorSelections) {
    try {
      const decodedCookie = decodeURIComponent(configuratorSelections);
      const selections = JSON.parse(decodedCookie);

      // Ignore cookie if it belongs to a different product
      const currentHandle = configJson.product ? configJson.product.handle : "";
      const cookieHandle = selections.product_handle || "";
      if (cookieHandle && currentHandle && cookieHandle !== currentHandle) {
        // Different product, ignore stale cookie
      } else {
        if (selections.current_paper) {
          configJson.current_paper = window.configJson.current_paper =
            selections.current_paper;
          CONFIGURATOR.current_paper = selections.current_paper;
        }

        if (selections.current_cut !== undefined) {
          CONFIGURATOR.current_cut = selections.current_cut;
        }
      }
    } catch (error) {
      console.error("Erreur parsing cookie configurator_selections:", error);
    }
  }
}

profil = urlParams.get("ref_profil");

let preview_color = null;

let p_obj = null;
if (profil) {
  const _want = profil.toLowerCase().trim();
  // Prefer a matching profile that actually carries a palette. Handles duplicate
  // "profil" metaobjects (e.g. two QUADRI, one empty) regardless of their order;
  // falls back to the first match when none has a palette.
  p_obj =
    profils.find(
      (p) =>
        p.ref_profil.toLowerCase().trim() === _want &&
        p.colors &&
        p.colors.length > 0,
    ) || profils.find((p) => p.ref_profil.toLowerCase().trim() === _want);

  if (p_obj) {
    CONFIGURATOR.ref_profil = p_obj.ref_profil;
    CONFIGURATOR.format_imposition = p_obj.format_imposition;
    preview_color = p_obj.preview_color;

    // A palette of raw hex colours ("#777B7E") = single-ink profile (1COLOR):
    // the whole design is recoloured with one spot colour, so set is1color + a
    // default preview_color. A palette of theme refs ("TH001") = multi-colour
    // theme profile (QUADRI): each entry is applied via editor.applyProductTheme
    // and must NOT carry a single preview_color. Never infer 1-colour from mere
    // palette presence — that is what emptied QUADRI's colour drawer.
    const _cols = p_obj.colors || [];
    // Ink palette (1COLOR) = colours with no theme ref (recolour via hex);
    // theme palette (QUADRI) = colours carrying a "TH###" ref (applyProductTheme).
    const _isInkPalette = _cols.length > 0 && !_cols[0].ref;
    if (_isInkPalette) {
      is1color = true;
      preview_color = _cols[0].hexa;
    } else if (
      p_obj.ref_profil !== "WHITE" &&
      p_obj.ref_profil !== "QUADRI-WHITE"
    ) {
      preview_color = "";
    }

    // Pour le profil WHITE, forcer le contenu en blanc
    if (p_obj.ref_profil === "WHITE") {
      preview_color = "#FFFFFF";
    }

    // QUADRI-WHITE: white ink on colored paper — use metaobject preview_color if set, else default to white
    if (p_obj.ref_profil === "QUADRI-WHITE") {
      if (!preview_color || preview_color === "") preview_color = "#FFFFFF";
    }

    // Initialize texture for 3DFOIL and 3DVARNISH profiles if not already set
    if (
      p_obj.textures &&
      p_obj.textures.length > 0 &&
      !CONFIGURATOR.ref_texture
    ) {
      CONFIGURATOR.ref_texture = p_obj.textures[0].filename;
    }
  }
}

// A saved creation can carry a ref_profil the product no longer offers (profil
// renamed, design re-imported, link built by hand). Without a fallback every
// later p_obj.* access throws and nothing paints — the blank configurator
// reported on 2026-09-19. Falling back to the product's first profil keeps the
// editor usable, and the warning says what happened.
if (!p_obj && typeof profils !== "undefined" && profils && profils.length) {
  p_obj = profils[0];
  CONFIGURATOR.ref_profil = p_obj.ref_profil;
  preview_color = p_obj.preview_color || preview_color;
  console.warn(
    `[configurateur] profil "${profil}" absent de ce produit — repli sur "${p_obj.ref_profil}"`,
  );
}

if (profil == "1COLOR") {
  is1color = true;
}

let current_cut = CONFIGURATOR.current_cut ? CONFIGURATOR.current_cut : "00";
// format_imposition comes from the profil, but a creation saved before a profil
// change can arrive without it: fall back to the resolved profil, then to the
// format table, rather than throwing on toLowerCase().
if (!CONFIGURATOR.format_imposition) {
  CONFIGURATOR.format_imposition =
    (p_obj && p_obj.format_imposition) ||
    (typeof configurator !== "undefined" && configurator.format_imposition) ||
    "";
}
let imposition_format = String(CONFIGURATOR.format_imposition).toLowerCase();

let index_cut = configJson.format.ref_cut.indexOf("CUT" + current_cut);
const _impositions = configJson.format[`imposition_${imposition_format}`];
let current_imposition = CONFIGURATOR.current_imposition
  ? CONFIGURATOR.current_imposition
  : _impositions
    ? _impositions[index_cut]
    : undefined;

CONFIGURATOR.current_cut = current_cut;
CONFIGURATOR.current_imposition = current_imposition;

// ref_profil is already set by the profils loop above (with normalized case)
// Only set from URL if not already resolved from profils
if (!CONFIGURATOR.ref_profil) {
  CONFIGURATOR.ref_profil = urlParams.get("ref_profil");
}

configJson.item_options = {};

let css = "";
// p_obj is guaranteed by the fallback above, but tab_disabled is an optional
// metaobject field: an empty one used to take the whole script down with it.
let tabs_disabled = ((p_obj && p_obj.tab_disabled) || "").split(",");

var defaultEditorConfig = {
  // theme: "1001Cartes",
  defaultLanguage: "fr",
  customStyle: "user",
  preloader: {
    firstTimeMessage:
      "Chargement de l'application et préparation de votre produit en cours...",
    errorMessage: "Impossible de charger le produit!",
    enabled: true,
  },
  objectInspectorVisible: true,
  canvas: {
    containerColor: "#FFFFFF",
    // Keep foil/varnish/spotColor channels at full opacity when the Base tab is active.
    // Default CC behavior dims inactive channel containers — invisible foil until user clicks the tab.
    inactiveContainerTransparencyEnabled: false,
    inactiveContainerTransparencyLevel: 0,
    objectInspectorVisible: true,
    printZone: {
      trim: { color: "rgba(0,0,0,0)" },
    },
    // Crop-via-grips on placeholders (Adobe Express style): resizing a placeholder
    // crops/zooms the image instead of stretching it. CC 7.2.7 disabled it
    // server-side (placeholderCropMode:false); re-enable so the user images we
    // convert to placeholders resize in COVER/crop, not fill/stretch.
    handlers: { placeholderCropMode: true },
  },
  rendering: {
    proofImageSafetyLinesEnabled: false,
    proofImageSpineAndFoldingLinesEnabled: false,
    proofImageFileFormat: p_obj.preview_mockup_file_extension,
  },
  productThemes: productThemes,
  // Override the server image defaults. The 7.2.7 server clientConfig added
  // resizeGrips.edge:true on images (absent in 7.1.8) → user-added photos became
  // deformable. Drop the edge grips so they resize proportionally from the
  // corners only (no stretching), restoring the 7.1.8 behaviour. itemConfig on
  // the Toolbox button does NOT propagate to images — defaultItemsConfig.image
  // is the level that governs them. All item types are copied from the server
  // config so overriding this key can't wipe the other defaults (text/shape/…).
  defaultItemsConfig: {
    text: {
      font: { postScriptName: "Roboto-Regular", size: 24 },
      text: "Votre titre",
      color: "cmyk(0%, 0%, 0%, 100%, 100%)",
    },
    richText: {
      alignment: "Center",
      font: { postScriptName: "Roboto-Regular", size: 16 },
      text: "Saisissez votre texte ici",
      color: "cmyk(0%, 0%, 0%, 100%, 100%)",
      height: "15%",
      width: "75%",
    },
    rectangle: {
      borderWidth: 0,
      borderColor: "cmyk(0%, 0%, 0%, 100%, 100%)",
      fillColor: "cmyk(0%, 0%, 0%, 25%, 100%)",
      height: 200,
      width: 200,
    },
    ellipse: {
      borderWidth: 0,
      borderColor: "cmyk(0%, 0%, 0%, 100%, 100%)",
      fillColor: "cmyk(0%, 0%, 0%, 25%, 100%)",
      height: 200,
      width: 200,
    },
    image: {
      borderWidth: 0,
      height: "50%",
      width: "50%",
      textWrappingMode: "none",
      adjustSize: true,
      // edge:false → no middle grips. corner:["Proportional"] → corner resize
      // keeps the aspect ratio (no deformation). "Arbitrary" alone allowed free,
      // ratio-breaking corner resize. This mirrors Magento's "Image" gallery.
      manipulationPermissions: {
        resizeGrips: { edge: false, corner: ["Proportional"] },
      },
    },
    barcode: {
      color: "cmyk(0%, 0%, 0%, 100%, 100%)",
    },
  },
  assetSources: {
    "My files": {
      type: "PrivateSource",
      allowedExtensions: [
        "jpg",
        "jpeg",
        "pdf",
        "png",
        "gif",
        "svg",
        "tif",
        "tiff",
        "bmp",
        "ai",
      ],
      actionMode: {
        svg: "Vector",
        pdf: "Vector",
      },
      groupingByDateEnabled: false,
      overwrite: false,
      autoInsertUploadedFile: false,
    },
    "Background Images": {
      type: "PublicSource",
      rootCategory: { name: "Backgrounds/Backgrounds" },
      allowedExtensions: ["jpg", "jpeg", "png"],
    },
    "Shapes Images": {
      type: "PublicSource",
      rootCategory: { name: "Cliparts/Cliparts" },
      allowedExtensions: ["psd", "ai", "svg"],
      actionMode: {
        // Clipart files are PSD. "Merged" flattens them to a raster image (the
        // regression). "Group" keeps one object but needs ungroup before
        // recolouring. "Design" imports the layers as editable objects so colours
        // can be changed directly. True SVG-clipart behaviour needs .svg files.
        psd: "Design",
        svg: "Clipart",
        pdf: "Shape",
      },
    },
    "Frames Images": {
      type: "PublicSource",
      rootCategory: { name: "Frames/Frames" },
    },
  },
  widgets: {
    common: {
      textFormattingEnabled: true,
      fontSize: {
        min: 4,
        max: 1296,
        step: 12,
      },
      tracking: {
        min: -300,
        max: 300,
        step: 10,
      },
      leading: {
        min: 6,
        max: 1296,
        step: 12,
      },
    },
    Toolbox: {
      // Newly added images go on top of existing elements instead of behind
      // them (CC default is false → new image treated as background).
      insertOnTop: true,
      buttons: [
        {
          // Single text type: clicking adds a bounded text block directly
          // (no Text / BoundedText submenu).
          action: "BoundedText",
          translationKey: "Toolbox.TEXT",
          translationKeyTitle: "Toolbox.TITLE_ADD_TEXT",
          iconClass: "cc-icon-add-text",
        },
        "Image",
        {
          translationKey: "Toolbox.SHAPE",
          translationKeyTitle: "Toolbox.TITLE_ADD_SHAPE",
          iconClass: "cc-icon-add-shape",
          buttons: ["Line", "rectangle", "Ellipse"],
        },
        {
          translationKey: "Toolbox.LINEAR_BARCODE",
          translationKeyTitle: "Toolbox.TITLE_ADD_LINEAR_BARCODE",
          iconClass: "cc-icon-qr-code",
          buttons: ["LinearBarcode", "QrCode", "DataMatrixBarcode"],
        },
        {
          action: "Image",
          translationKey: "Clipart",
          translationKeyTitle: "Clipart",
          iconClass: "cc-icon-clipart",
          tabs: ["Shape Tab"],
        },
        {
          action: "Image",
          translationKey: "Cadre",
          translationKeyTitle: "Cadre",
          iconClass: "cc-icon-cadre",
          tabs: ["Frame Tab"],
        },
        {
          action: "Background",
          translationKey: "Fond",
          translationKeyTitle: "Fond",
          iconClass: "cc-icon-fond",
          tabs: ["Background Tab"],
        },
      ],
    },
    AssetManager: {
      enabledBackgroundChange: true,
      maxUploadFileSize: null,
      saveAllowedTabAfterInsert: false,
      defaultSortOrder: "desc",
      tabs: [
        {
          name: "My files",
          assetSourceInstance: "My files",
          iconClassName: "cc-icon-uploadable",
          isCoverMode: true,
          controls: {
            toolbarEnabled: false,
            assetNameEnabled: false,
            extensionEnabled: false,
            selectAllButtonEnabled: false,
            multiSelectEnabled: true,
          },
        },
        {
          name: "Shape Tab",
          assetSourceInstance: "Shapes Images",
          iconClassName: "cc-icon-add-image",
          controls: { insertToAllButtonEnabled: true },
        },
        {
          name: "Frame Tab",
          assetSourceInstance: "Frames Images",
          iconClassName: "cc-icon-add-image",
          controls: { insertToAllButtonEnabled: true },
        },
        {
          name: "Background Tab",
          assetSourceInstance: "Background Images",
          iconClassName: "cc-icon-add-image",
          controls: {
            toolbarEnabled: false,
            assetNameEnabled: false,
            extensionEnabled: false,
            selectAllButtonEnabled: false,
            multiSelectEnabled: true,
          },
        },
      ],
    },
  },
};

defaultEditorConfig.widgets.Toolbox.buttons =
  defaultEditorConfig.widgets.Toolbox.buttons.filter((button) => {
    console.log(button.translationKeyTitle);
    if (
      button.translationKeyTitle === "Fond" &&
      tabs_disabled.includes("Background")
    ) {
      return false;
    }
    if (
      button.translationKeyTitle === "Clipart" &&
      tabs_disabled.includes("Clipart")
    ) {
      return false;
    }
    if (
      button.translationKeyTitle === "Cadre" &&
      tabs_disabled.includes("Frame")
    ) {
      return false;
    }
    return true;
  });

defaultEditorConfig.widgets.AssetManager.tabs =
  defaultEditorConfig.widgets.AssetManager.tabs.filter((button) => {
    if (
      button.name === "Background Tab" &&
      tabs_disabled.includes("Background")
    ) {
      return false;
    }
    if (button.name === "Shape Tab" && tabs_disabled.includes("Clipart")) {
      return false;
    }
    if (
      button.translationKeyTitle === "Frame Tab" &&
      tabs_disabled.includes("Frame")
    ) {
      return false;
    }
    return true;
  });

//'lctq1bglebkwec05'
//'b626324d-d6c7-4a46-a74e-a496d206c70b'

async function initUser() {
  // Merchant correction (state=admin-edit): open the CUSTOMER's CC state — the
  // order's _userId comes from the edit link, not the merchant's own session.
  // saveProduct(currentStateId) then keeps saving under that same user, so the
  // order's stored _userId stays valid for the HiRes regeneration.
  if (window.ADMIN_EDIT && window.ADMIN_EDIT.userId) {
    const adminEditUser = window.ADMIN_EDIT.userId;
    let adminToken = await getTokenId(adminEditUser);
    if (!adminToken) {
      adminToken = await createTokenId(adminEditUser);
    }
    defaultEditorConfig.tokenId = adminToken;
    defaultEditorConfig.userId = adminEditUser;
    return;
  }

  // NEW VERSION

  const user_logged = userId && userId != "" ? true : false;
  let session = getCookie("userId");

  if (user_logged) {
    let token = null;

    // get user token
    token = await getTokenId(userId);

    if (!token) {
      // create new token
      token = await createTokenId(userId);
    }

    defaultEditorConfig.tokenId = token;
    defaultEditorConfig.userId = userId.toString();
  } else {
    // get user session cookie

    if (session) {
      // get token from session
      let token = await getTokenId(session);
      if (token) {
        defaultEditorConfig.tokenId = token;
      } else {
        // create new token
        let token = await createTokenId(session);
        defaultEditorConfig.tokenId = token;
      }
      defaultEditorConfig.userId = session;
    } else {
      // create new session
      let session =
        Math.random().toString(36).substring(2, 10) +
        Math.random().toString(36).substring(2, 10);
      setCookie("userId", session);
      let token = await createTokenId(session);
      defaultEditorConfig.tokenId = token;
      defaultEditorConfig.userId = session;
    }
  }
}

async function getTokenId(id) {
  var token = (
    await (
      await fetch(
        window.SERVICE_URLS.de + "/api/Auth/Users/" + id + "/Tokens",

        {
          method: "GET",
          headers: { "X-CustomersCanvasAPIKey": "128ed921f31f122aa8129f291d" },
        },
      )
    ).json()
  ).tokens[0]?.tokenId;

  return token;
}

async function createTokenId(id) {
  var token = (
    await (
      await fetch(
        window.SERVICE_URLS.de + "/api/Auth/Users/" + id + "/Tokens",

        {
          method: "POST",
          headers: { "X-CustomersCanvasAPIKey": "128ed921f31f122aa8129f291d" },
        },
      )
    ).json()
  ).tokenId;

  return token;
}

if (CONFIGURATOR.current_color && CONFIGURATOR.current_color != "") {
  defaultEditorConfig.defaultProductTheme = CONFIGURATOR.current_color;
}

console.log(defaultEditorConfig);
var editor;
var mockups = {};
var paperMockups = {};

// Generate cutting mockups: CuttingMockups/{format.ref}/P{page}/{ref_cut}
// Name is unique per cut (not per page) so CC re-renders the up overlay when
// the cut changes. Same name across pages keeps CC's per-page cache stable.
for (var i = 1; i < configJson.format.ref_pages.length + 1; i++) {
  for (var y = 0; y < configJson.format.ref_cut.length; y++) {
    mockups[`${i}-${y}`] = [
      {
        mockup: {
          name: `mockup_cut_${y}`,
          up: `CuttingMockups/${configJson.format.ref}/P${i}/${configJson.format.ref_cut[y]}`,
        },
      },
    ];
  }
}

// Generate paper mockups: SupportMockups/{format.ref}/{paper}
// Applied as "down" (background layer)
function initPaperMockups() {
  if (
    typeof papersData === "undefined" ||
    !papersData ||
    !papersData.file_paper
  ) {
    console.log("initPaperMockups: papersData non disponible");
    return;
  }

  for (var paperIdx = 0; paperIdx < papersData.file_paper.length; paperIdx++) {
    const paperRef = papersData.file_paper[paperIdx]; // ex: "300BK"

    // Format: SupportMockups/CSRV03/300BK (NO extension)
    paperMockups[paperIdx] = {
      mockup: {
        name: "paper_mockup",
        down: `SupportMockups/${configJson.format.ref}/${paperRef}`,
      },
    };
  }

  console.log(
    "paperMockups initialisés:",
    Object.keys(paperMockups).length,
    "combinaisons",
  );
}

// Helper: SupportMockups/{format.ref}/{paper}
function getPaperMockupPath(paperRef) {
  return `SupportMockups/${configJson.format.ref}/${paperRef}`;
}

function initProduct(product) {
  /**
   * Event listener for cut selection
   * Restored here because this initProduct overrides the one in
   * w-configurateur-product.js (now renamed initProductListeners), so the
   * listener attached there wasn't reaching the user. Avoids the previous
   * paperItem.click() simulated cascade — calls applyCut directly.
   */
  console.log("INIT PRODUCT");
  let selectCut = document.querySelector("product-drawer-decoupe .drawer-list");
  if (selectCut) {
    selectCut.querySelectorAll("[data-value]").forEach((elem) => {
      elem.addEventListener("click", function (e) {
        selectCut.querySelectorAll("[data-value]").forEach((it) => {
          it.classList.remove("actif");
        });
        let value = elem.dataset.value;
        current_cut = value;
        CONFIGURATOR.current_cut = value;

        try {
          CONFIGURATOR.current_imposition =
            configJson.format[`imposition_${imposition_format}`][
              configJson.format.ref_cut.indexOf("CUT" + current_cut)
            ];
        } catch (err) {
          /* imposition not always set */
        }

        elem.classList.add("actif");

        const cut_title = elem.dataset.cutTitle;
        const decoupeValue = document.querySelector(".decoupe-value");
        if (decoupeValue) decoupeValue.innerHTML = cut_title;

        const price = parseInt(elem.dataset.price);
        const decoupeBtn = document.querySelector(
          ".drawer-button[data-id='decoupe']",
        );
        if (decoupeBtn) decoupeBtn.dataset.price = price;

        document.querySelector("w-product-template").closeDrawer();

        // Apply the cut. Use IframeLoader if available (lighter than full
        // LoadMask). Skip applyOption (heavy external API) — gallery is
        // regenerated on Save / Order.
        const overlay =
          typeof IframeLoader !== "undefined"
            ? IframeLoader.show("Application de la découpe...")
            : null;
        const result = applyCut();
        const unmask = () => {
          if (overlay && typeof IframeLoader !== "undefined") {
            IframeLoader.hide(overlay);
          }
        };
        if (result && typeof result.then === "function") {
          result.finally(() => setTimeout(unmask, 1500));
        } else {
          setTimeout(unmask, 1800);
        }
      });
    });

    // On load, reflect CONFIGURATOR.current_cut in the drawer UI. The Liquid
    // template marks the first cut (CUT00 / "Droite") as actif by default;
    // without this the drawer keeps showing "Droite" even when current_cut is
    // e.g. "03" (Biseau). The cut mockup itself is applied later by applyCut().
    const _targetCut = (CONFIGURATOR.current_cut || "00").toString();
    const _activeCut =
      selectCut.querySelector(`[data-value="${_targetCut}"]`) ||
      selectCut.querySelector("[data-value]");
    if (_activeCut) {
      selectCut
        .querySelectorAll("[data-value]")
        .forEach((it) => it.classList.remove("actif"));
      _activeCut.classList.add("actif");
      const _decoupeBtn = document.querySelector(
        ".drawer-button[data-id='decoupe']",
      );
      if (_decoupeBtn)
        _decoupeBtn.dataset.price = parseInt(_activeCut.dataset.price) || 0;
      const _decoupeValue = document.querySelector(".decoupe-value");
      if (_decoupeValue) _decoupeValue.innerHTML = _activeCut.dataset.cutTitle;
    }
  }

  /***
   * Colour drawer — driven by the profile palette (metaobject field
   * palette_couleur_one_color_preview, exposed as p_obj.colors). Palette present
   * => show + populate the matching drawer; palette absent => hide the colour
   * buttons (foil / varnish profiles have no palette). Routing is by palette
   * type, NOT is1color:
   *   - theme palette (hex "#…" absent on ref) -> product-drawer-couleur  + applyProductTheme(themeRef)
   *   - ink palette   (hex "#777B7E")          -> product-drawer-1couleur + applyPreviewColor(hex)
   * The theme swatches read ref/hex/name from configJson.themes_colors (already
   * parsed with the real hex), keyed by the same palette as the profile.
   */
  const _palette = p_obj && p_obj.colors ? p_obj.colors : [];
  const _hasPalette = _palette.length > 0;
  // Route by palette kind: ink (1COLOR) carries no ref, theme (QUADRI) carries a ref.
  const _isInkPalette = _hasPalette && !_palette[0].ref;

  // Theme swatches now come straight from the profile palette (p_obj.colors),
  // which carries ref ("TH###"), hexa ("#…") and name — the product metafield
  // custom.themes_couleurs is no longer used. No palette on the profile => the
  // button is hidden below (empty drawer never opens).
  const selectColor = document.querySelector(
    "product-drawer-couleur .drawer--list",
  );
  const select1Color = document.querySelector(
    "product-drawer-1couleur .drawer--list",
  );

  let _colorDrawerFilled = false;
  if (_hasPalette && !_isInkPalette && selectColor) {
    for (let i = 0; i < _palette.length; i++) {
      const option = document.createElement("div");
      option.setAttribute("data-color-name", _palette[i].name);
      option.dataset.value = _palette[i].ref;
      const bubble = document.createElement("span");
      bubble.style.backgroundColor = _palette[i].hexa;
      option.textContent = _palette[i].name;
      option.appendChild(bubble);
      selectColor.appendChild(option);
    }
    selectColor.querySelectorAll("div").forEach((elem) => {
      elem.addEventListener("click", function () {
        selectColor
          .querySelectorAll("div")
          .forEach((el) => el.classList.remove("active"));
        const value = elem.dataset.value;
        editor.applyProductTheme(value);
        document.querySelector("w-product-template").closeDrawer();
        CONFIGURATOR.current_color = value;
      });
    });
    _colorDrawerFilled = true;
  }

  let _1colorDrawerFilled = false;
  if (_hasPalette && _isInkPalette && select1Color) {
    for (let i = 0; i < _palette.length; i++) {
      const option = document.createElement("div");
      option.setAttribute("data-color-name", _palette[i].name);
      option.dataset.value = _palette[i].hexa;
      const bubble = document.createElement("span");
      bubble.style.backgroundColor = _palette[i].hexa;
      option.textContent = _palette[i].name;
      option.appendChild(bubble);
      select1Color.appendChild(option);
    }
    select1Color.querySelectorAll("div").forEach((elem) => {
      elem.addEventListener("click", function () {
        select1Color
          .querySelectorAll("div")
          .forEach((el) => el.classList.remove("active"));
        const value = elem.dataset.value;
        applyPreviewColor(value);
        preview_color = value;
        document.querySelector("w-product-template").closeDrawer();
        CONFIGURATOR.current_color = value;
      });
    });
    _1colorDrawerFilled = true;
  }

  // Hide each colour button whose drawer ended up empty so it never opens a
  // blank drawer: no palette at all, or a theme palette whose product metafield
  // (custom.themes_couleurs) is empty. The data-profil script in
  // w-configurator-customize.liquid only shows the button by profile match and
  // cannot tell the swatch source is empty — this runs after it and overrides.
  if (!_colorDrawerFilled) {
    document
      .querySelector(".drawer-button[data-id='couleur']")
      ?.style.setProperty("display", "none");
  }
  if (!_1colorDrawerFilled) {
    document
      .querySelector(".drawer-button[data-id='1couleur']")
      ?.style.setProperty("display", "none");
  }

  /***
   * Texture drawer (only present for 3DFOIL / QUADRI3DFOIL profiles)
   * Guard against null: this drawer is absent on most products and the
   * unguarded querySelectorAll was throwing → killing the whole initProduct
   * → loadProduct never called → CC iframe stayed empty.
   */
  let selectTexture = document.querySelector(
    "product-drawer-texture .drawer--list",
  );

  if (selectTexture) {
    selectTexture.querySelectorAll("[data-texture-title]").forEach((elem) => {
      elem.addEventListener("click", function (e) {
        selectTexture
          .querySelectorAll("[data-texture-title]")
          .forEach((elem) => {
            elem.classList.remove("actif");
          });
        let value = elem.dataset.value;

        elem.classList.add("actif");

        CONFIGURATOR.ref_texture = value;

        // Apply texture for all profiles that have textures
        console.log("🎨 Texture selected:", CONFIGURATOR.ref_texture);
        applyPreviewTexture(CONFIGURATOR.ref_texture);

        document.querySelector("w-product-template").closeDrawer();
      });
    });
  }

  // Defines product's surfaces
  if (!product) {
    console.log("INIT product def");

    const getDesignFile = (index, page) => {
      let profil = p_obj.ref_profil.toUpperCase();
      let suffix = "";
      if (
        profil === "QUADRI3DFOIL" ||
        profil === "3DFOIL" ||
        profil === "QUADRI3DVARNISH" ||
        profil === "3DVARNISH"
      ) {
        suffix = "-SPOT";
      } else if (profil === "QUADRI-WHITE") {
        suffix = "-W";
      }
      return `${configJson.format.path_page[index]}${configJson.ref_design}${suffix}_${page}`;
    };

    const getTexturePath = () => {
      const name = CONFIGURATOR.ref_texture.endsWith(".jpg")
        ? CONFIGURATOR.ref_texture
        : CONFIGURATOR.ref_texture + ".jpg";
      return `Effects/${name}`;
    };

    const getFoilColor = () => {
      const foilColors = {
        "FOIL01.jpg": "rgb(218, 165, 32)", // Or / Gold
        FOIL01: "rgb(218, 165, 32)",
        "FOIL02.jpg": "rgb(192, 192, 192)", // Argent / Silver
        FOIL02: "rgb(192, 192, 192)",
        "FOIL03.jpg": "rgb(184, 115, 51)", // Cuivre / Copper/Rose Gold
        FOIL03: "rgb(184, 115, 51)",
      };
      return foilColors[CONFIGURATOR.ref_texture] || "rgb(218, 165, 32)"; // Default to gold
    };

    const getMockupPath = (index) => {
      return `CuttingMockups/${configJson.format.ref}/P${
        index + 1
      }/CUT${current_cut}`;
    };

    const createContainers = (index) => {
      let containers = [];

      if (
        !["QUADRI3DFOIL", "3DFOIL", "QUADRI3DVARNISH", "3DVARNISH"].includes(
          p_obj.ref_profil.toUpperCase(),
        )
      ) {
        if (
          !is1color &&
          !p_obj.textures.length &&
          p_obj.ref_profil != "QUADRI" &&
          p_obj.ref_profil != "QUADRI-WHITE"
        ) {
          containers.push({
            name: "Main",
            type: "spotColor",
            previewColor: "rgba(0, 0, 0, 1)",
          });
        } else if (p_obj.ref_profil === "QUADRI-WHITE") {
          containers.push({
            name: "Main",
            type: "spotColor",
            previewColor: "#FFFFFF",
            outputColor: "#FFFFFF",
          });
        } else if (is1color && preview_color && preview_color !== "") {
          containers.push({
            name: "Main",
            type: "spotColor",
            previewColor: preview_color,
            outputColor: preview_color,
          });
        } else if (p_obj.textures.length > 0) {
          containers.push({
            name: "Main",
            type: "texture",
            texture: getTexturePath(),
          });
        }
      } else {
        // 3DFOIL: Effects container is NOT declared here — CC auto-creates the
        // texture container from the PSD's <CN_Effects><TFP_textures/Effects/FOIL01.jpg>
        // group marker (lsct=1 OPEN_FOLDER, blend=norm). Pattern matches Z98 working setup.
        // VARNISH (decoupled from foil): only the spot group renders as a flat
        // varnish colour — never the foil texture. The -SPOT PSD is shared with
        // 3DFOIL: the "Effects" container carries a
        // <CN_Effects><TFP_textures/Effects/FOIL01.jpg> marker (CC auto-creates a
        // foil texture container from it), while "Main" holds the QUADRI colour
        // base (flower image + body text). We override ONLY "Effects" with a flat
        // spotColor (a runtime update() cannot convert texture->spotColor) and
        // leave "Main" untouched so it keeps rendering in full colour — exactly
        // like QUADRI3DFOIL keeps its colour base. Declared on all pages (the
        // verso "Effects" may be empty, which is harmless).
        // previewColor = profile colour (e.g. #5bff3b green) or black when none
        // (plain 3DVARNISH: "tout ce que vous voyez en noir sera imprimé en vernis").
        const profil3D = p_obj.ref_profil.toUpperCase();
        const isVarnish =
          profil3D === "QUADRI3DVARNISH" || profil3D === "3DVARNISH";
        if (isVarnish) {
          const varnishColor =
            preview_color && preview_color !== "" ? preview_color : "#000000";
          containers.push({
            name: "Effects",
            type: "spotColor",
            previewColor: varnishColor,
            outputColor: "#000000",
          });
        }
        // Background must be declared on ALL pages: if a page's PSD lacks a <BG>
        // marker layer (G80 P2 case), CC otherwise auto-creates an empty
        // SurfaceContainer with a PlaceholderItem that covers the whole creation.
        const _initPaper =
          CONFIGURATOR.current_paper || configJson.current_paper;
        if (_initPaper) {
          containers.push({
            name: "Background",
            type: "spotColor",
            previewColor: PAPER_COLORS[_initPaper] || "#F5F5F5",
          });
        }
      }
      return containers;
    };

    product = {
      defaultSafetyLines: [],
      surfaces: configJson.format.ref_pages.map((page, index) => {
        console.log("def0");
        console.log(configJson.format.pages_name);

        let res = {
          name: configJson.format.pages_name[index],
          printAreas: [
            { designFile: getDesignFile(index, page), safetyLines: [] },
          ],
          mockup: { up: getMockupPath(index) },
        };

        const containers = createContainers(index);
        if (containers.length > 0) {
          res.containers = containers;
        }

        console.log("def2");
        return res;
      }),
    };
  }
  console.log("PRODUCT DATA");

  console.log(product);
  console.log("END -- INIT PRODUCT");

  var editorConfig = defaultEditorConfig;

  function handleError(error, message) {
    console.error(message, error);
    return error;
  }

  var loadData = null;

  var loadProduct = async function (product, editorConfig) {
    var frameParent = $j("#editorFrame").parent()[0];
    var settings = {
      logoUrl:
        "https://www.1001cartes.com/skin/frontend/printissime/millesetunecartes/images/logo_small.png",
      logoHref: "https://www.1001cartes.com/",
      onClickSaveButton: async function (result) {
        LoadMask.maskMessage(frameParent, "Enregistrement en cours...");
        saveData = result;
        // Required: without it the proof still carries the cut mockup and its
        // green trim marks.
        await removeCut();
        if (
          (!is1color || p_obj.ref_profil === "WHITE") &&
          preview_color &&
          preview_color != ""
        ) {
          await applyPreviewColor(preview_color);
        }

        if (!customer_id) {
          // Save product to CC + generate proofs/mockups BEFORE redirecting to
          // login, so the pending wishlist item has a valid _preview image and
          // _proofsImages array. Without this, the creation flushed post-login
          // gets _preview:null and a broken thumbnail in "Mes créations".
          try {
            let saveResult;
            if (
              typeof currentStateId == "string" &&
              currentStateId.length > 0
            ) {
              saveResult = await editor.saveProduct(currentStateId);
            } else {
              saveResult = await editor.saveProduct();
            }
            saveData = saveResult;
            currentStateId = saveResult.stateId;
            CONFIGURATOR.ref_configuration = saveResult.stateId;

            approveData = await editor.getProofImages({
              maxWidth: 1200,
              maxHeight: imageMaxHeight,
            });
            CONFIGURATOR.proofsImages = [];
            for (const img of approveData.proofImageUrls) {
              CONFIGURATOR.proofsImages.push(img[0]);
            }

            let mockupApproveData = approveData;
            if (
              p_obj.ref_profil &&
              p_obj.ref_profil.toUpperCase().includes("WHITE")
            ) {
              // Transparent background so the paper layer shows through; keep design white
              const originalContainerColor =
                defaultEditorConfig.canvas.containerColor;
              defaultEditorConfig.canvas.containerColor = "transparent";
              const transparentProofData = await editor.getProofImages({
                maxWidth: 1200,
                maxHeight: imageMaxHeight,
                fileFormat: "png",
              });
              defaultEditorConfig.canvas.containerColor =
                originalContainerColor;
              mockupApproveData = transparentProofData;
            }

            mockupPreviewsImages = await getMockupPreview(
              mockupApproveData,
              "ProofPreviewMockups",
              client_bon_a_tirer_nombre_mockups_preview_generes,
            );
          } catch (error) {
            console.error(
              "Error saving/generating preview before login redirect:",
              error,
            );
          }
          redirectUserAndSaveCreation(saveData);
          LoadMask.unmaskElement(frameParent);
        } else {
          if (typeof currentStateId == "string" && currentStateId.length > 0) {
            await editor
              .saveProduct(currentStateId)
              .then(function (result) {
                saveData = result;
                currentStateId = result.stateId;
                CONFIGURATOR.ref_configuration = result.stateId;
              })
              .catch(function (error) {
                saveData = handleError(
                  error,
                  "Impossible d'enregistrer la création",
                );
              });
          } else {
            await editor
              .saveProduct()
              .then(function (result) {
                saveData = result;
                currentStateId = result.stateId;
                CONFIGURATOR.ref_configuration = result.stateId;
              })
              .catch(function (error) {
                saveData = handleError(
                  error,
                  "Impossible d'enregistrer la création",
                );
              });
          }
          try {
            approveData = await editor.getProofImages({
              maxWidth: 1200,
              maxHeight: imageMaxHeight,
            });
            CONFIGURATOR.proofsImages = [];
            for (const img of approveData.proofImageUrls) {
              CONFIGURATOR.proofsImages.push(img[0]);
            }

            // WHITE profile: transparent background so paper texture shows through, white design preserved
            let mockupApproveData = approveData;
            if (
              p_obj.ref_profil &&
              p_obj.ref_profil.toUpperCase().includes("WHITE")
            ) {
              const originalContainerColor =
                defaultEditorConfig.canvas.containerColor;
              defaultEditorConfig.canvas.containerColor = "transparent";
              const transparentProofData = await editor.getProofImages({
                maxWidth: 1200,
                maxHeight: imageMaxHeight,
                fileFormat: "png",
              });
              defaultEditorConfig.canvas.containerColor =
                originalContainerColor;
              mockupApproveData = transparentProofData;
            }

            mockupPreviewsImages = await getMockupPreview(
              mockupApproveData,
              "ProofPreviewMockups",
              client_bon_a_tirer_nombre_mockups_preview_generes,
            );

            const saveOk = await saveCreationWishlist(
              mockupPreviewsImages,
              CONFIGURATOR.proofsImages,
            );

            if (urlParams.get("state") == "creation_duplicated") {
              LoadMask.maskMessage(frameParent, "Duplication effectué ✅");
              setTimeout(function () {
                if (urlParams.get("state") == "creation_duplicated") {
                  LoadMask.unmaskElement(frameParent);
                }
              }, 1500);
            } else if (saveOk) {
              LoadMask.maskMessage(
                frameParent,
                "Enregistrement effectué dans Mon compte / Mes créations ✅",
              );
            } else {
              LoadMask.maskMessage(
                frameParent,
                "Erreur lors de l'enregistrement. Veuillez réessayer.",
              );
            }

            document.querySelector("[data-cut-title].actif")?.click();
            if (
              (!is1color || p_obj.ref_profil === "WHITE") &&
              preview_color &&
              preview_color != ""
            ) {
              await applyPreviewColor(preview_color);
            }
          } catch (err) {
            console.error("[onClickSaveButton] error:", err);
            LoadMask.maskMessage(
              frameParent,
              "Erreur lors de l'enregistrement. Veuillez réessayer.",
            );
          } finally {
            // 3s: the confirmation names where the creation was saved, so it has
            // to stay readable (1s went by before the customer could read it).
            setTimeout(function () {
              if (urlParams.get("state") != "creation_duplicated") {
                LoadMask.unmaskElement(frameParent);
              }
            }, 3000);
          }
        }
      },

      onClickOrderButton: async function (event) {
        LoadMask.maskMessage(
          frameParent,
          "Enregistrement de votre création et préparation du bon à tirer en cours...",
        );

        await removeCut();

        if (typeof currentStateId == "string" && currentStateId.length > 0) {
          editor
            .saveProduct(currentStateId)
            .then(function (result) {
              saveData = result;
              currentStateId = result.stateId;
              CONFIGURATOR.ref_configuration = result.stateId;
            })
            .catch(function (error) {
              saveData = handleError(
                error,
                "Impossible d'enregistrer la création",
              );
            });
        } else {
          editor
            .saveProduct()
            .then(function (result) {
              saveData = result;
              currentStateId = result.stateId;
              CONFIGURATOR.ref_configuration = result.stateId;
            })
            .catch(function (error) {
              saveData = handleError(
                error,
                "Impossible d'enregistrer la création",
              );
            });
        }

        if (
          (!is1color || p_obj.ref_profil === "WHITE") &&
          preview_color &&
          preview_color != ""
        ) {
          await applyPreviewColor(preview_color);
        }

        editor
          .getProofImages({ maxWidth: 1200, maxHeight: imageMaxHeight })
          .then(async function (result) {
            approveData = result;

            // WHITE profile: transparent background so paper texture shows through, white design preserved
            let mockupApproveData = approveData;
            if (
              p_obj.ref_profil &&
              p_obj.ref_profil.toUpperCase().includes("WHITE")
            ) {
              const originalContainerColor =
                defaultEditorConfig.canvas.containerColor;
              defaultEditorConfig.canvas.containerColor = "transparent";
              const transparentProofData = await editor.getProofImages({
                maxWidth: 1200,
                maxHeight: imageMaxHeight,
                fileFormat: "png",
              });
              defaultEditorConfig.canvas.containerColor =
                originalContainerColor;
              mockupApproveData = transparentProofData;
            }

            mockupPreviewsImages = await getMockupPreview(
              mockupApproveData,
              "ProofPreviewMockups",
              client_bon_a_tirer_nombre_mockups_preview_generes,
            );

            if (p_obj.textures && p_obj.textures.length > 0) {
              CONFIGURATOR.proofImagesBlack = mockupPreviewsImages;
            }

            const proofsImages = [];
            for (const img of approveData.proofImageUrls) {
              proofsImages.push(img[0]);
            }

            CONFIGURATOR.proofsImages = proofsImages;

            console.log(proofsImages);

            saveCreationWishlist(mockupPreviewsImages);

            if (urlParams.get("state") == "update") {
              CONFIGURATOR.proofsImages = proofsImages;
              updateCreationCartItem(
                "/products/" +
                  configJson.product.handle +
                  "?step=configurator_options&ref_id=" +
                  currentStateId +
                  "&data=" +
                  encodeURIComponent(btoa(JSON.stringify(CONFIGURATOR))) +
                  "&ref_profil=" +
                  p_obj.ref_profil +
                  "&view=" +
                  generateRandomString(8),
              );
            } else if (urlParams.get("state") == "update_creation") {
              updateCreationCartItem(
                "/products/" +
                  configJson.product.handle +
                  "?step=configurator_options&ref_id=" +
                  currentStateId +
                  "&data=" +
                  encodeURIComponent(btoa(JSON.stringify(CONFIGURATOR))) +
                  "&ref_profil=" +
                  p_obj.ref_profil +
                  "&view=" +
                  generateRandomString(8),
              );
            } else {
              CONFIGURATOR.proofsImages = proofsImages;
              console.log(proofsImages);
              // state=admin-edit matches none of the state branches above and
              // lands here: re-propagate the correction context so the options
              // screen sends the fix to the print pipeline, not to the cart.
              window.location.replace(
                "/products/" +
                  configJson.product.handle +
                  "?step=configurator_options&ref_id=" +
                  currentStateId +
                  "&data=" +
                  encodeURIComponent(btoa(JSON.stringify(CONFIGURATOR))) +
                  "&ref_profil=" +
                  p_obj.ref_profil +
                  "&view=" +
                  generateRandomString(8) +
                  (window.ADMIN_EDIT ? "&" + window.ADMIN_EDIT.qs : ""),
              );
            }
          })
          .catch(function (error) {
            approveData = handleError(
              error,
              "Impossible d'enregistrer la création",
            );
            LoadMask.unmaskElement(frameParent);
          });
      },
    };
    await initUser();
    return init1001cEditor("editorFrame", product, editorConfig, settings);
  };

  var settings = {
    onUndo: null,
    onRedo: null,
  };

  loadProduct(product, editorConfig, settings)
    .then(function (_editor) {
      if (!_editor) {
        var frameParent = $j("#editorFrame").parent()[0];
        LoadMask.maskMessage(
          frameParent,
          "Impossible de charger l'éditeur. Un fichier de gabarit est manquant dans le configurateur (voir console). Veuillez contacter le support.",
          true,
        );
        return;
      }
      editor = _editor;
      console.log("INIT editor");

      // Make user-added images behave as COVER (resize crops instead of stretching)
      // and land on top. Pausing this (2026-07-03) regressed side-resize-crop AND
      // z-order: the native CC flags (isCoverMode / insertOnTop / placeholderCropMode)
      // do NOT replicate it on 7.2.7, so the placeholder conversion is required.
      // Accepted trade-off: a PlaceholderItem's toolbar is more limited than a free
      // ImageItem's. Do not re-pause without a validated native replacement.
      try {
        enableCoverOnUserImages(editor);
      } catch (e) {
        console.warn("[cover] init failed", e);
      }

      applyCut();

      // Apply paper background directly (bypass click simulation — listeners from
      // w-configurator-customize.liquid may not be attached yet at this point).
      setTimeout(function () {
        if (typeof applyPaperBackground === "function") {
          applyPaperBackground();
        }
      }, 600);

      saveCreationAfterRedirect();
      if (
        preview_color &&
        (!is1color || p_obj.ref_profil === "WHITE") &&
        !(p_obj.ref_profil.toUpperCase() == "QUADRI3DVARNISH") &&
        preview_color != ""
      ) {
        applyPreviewColor(preview_color);
      }

      // Apply foil texture for 3DFOIL profiles
      const profil3D = p_obj.ref_profil.toUpperCase();
      console.log(
        "[3DFOIL check] profil3D=",
        profil3D,
        "ref_texture=",
        CONFIGURATOR.ref_texture,
      );
      if (profil3D === "3DFOIL" || profil3D === "QUADRI3DFOIL") {
        console.log("[3DFOIL] scheduling applyPreviewTexture in 800ms");
        setTimeout(() => {
          applyPreviewTexture(CONFIGURATOR.ref_texture);
        }, 800);
      }

      // 3DFOIL/3DVARNISH cleanup. The -SPOT PSDs put TEXT+Forme 2 inside the
      // <CN_Effects> group so they render in the foil texture container; that
      // leaves CC's default Main and Foreground SurfaceContainers empty. An
      // empty SurfaceContainer renders an "Add image" placeholder UI that
      // covers the whole creation. We do three things post-init:
      //  1) strip stub PlaceholderItems CC injected into Background when the
      //     PSD has no <BG> layer (G80 P2 case)
      //  2) remove the empty Main and Foreground SurfaceContainers entirely
      //     so they stop rendering the placeholder UI
      //  3) repoint userEditContainer to Effects on every surface — CC sets it
      //     to "Main" during init and keeps that reference even after we splice
      //     Main out of the collection, so new clipart/image inserts from the
      //     Toolbox target a ghost container and silently disappear. They only
      //     start landing visibly once the user clicks an existing foil item
      //     (which updates userEditContainer). Force the channel container as
      //     default so the first insert lands on the foil layer.
      if (
        ["3DFOIL", "QUADRI3DFOIL", "3DVARNISH", "QUADRI3DVARNISH"].includes(
          profil3D,
        )
      ) {
        setTimeout(() => {
          editor
            .eval(
              `
            try {
              const surfaces = globalThis.spEditor._canvasViewer._surfaceHandler._surface.parentProduct._surfaces._collection;
              let removedBg = 0, removedContainers = 0;
              for (const s of surfaces) {
                const containers = s._containers._collection;
                const bg = containers.find(c => c.name === 'Background');
                if (bg && bg._items) {
                  const coll = bg._items._collection;
                  for (let i = coll.length - 1; i >= 0; i--) {
                    const it = coll[i];
                    const isStub = it._isStubContent || !it._content || !it._name;
                    if (isStub) { coll.splice(i, 1); removedBg++; }
                  }
                }
                for (let i = containers.length - 1; i >= 0; i--) {
                  const c = containers[i];
                  const isSurfaceType = c.constructor && c.constructor.name === 'f';
                  const isEmpty = !c._items || !c._items._collection || c._items._collection.length === 0;
                  const isMainOrFg = c.name === 'Main' || c.name === 'Foreground';
                  if (isSurfaceType && isEmpty && isMainOrFg) {
                    containers.splice(i, 1);
                    removedContainers++;
                  }
                }
              }
              const cv = globalThis.spEditor._canvasViewer;
              if (cv._updateContainersFlatList) cv._updateContainersFlatList();
              const currentContainers = cv._surfaceHandler._surface._containers._collection;
              const fallback = currentContainers.find(c => c.name === 'Effects')
                || currentContainers.find(c => c.name === 'Background');
              let repointed = '';
              if (fallback && cv.userEditContainer !== fallback) {
                cv.userEditContainer = fallback;
                repointed = fallback.name;
              }
              if (cv._redraw) cv._redraw();
              else if (cv.redraw) cv.redraw();
              'bg=' + removedBg + ' containers=' + removedContainers + ' userEditContainer=' + (cv.userEditContainer && cv.userEditContainer.name) + ' repointed=' + repointed;
            } catch (e) { 'err: ' + e.message; }
          `,
            )
            .then((r) => console.log("[3DFOIL cleanup]", r));
        }, 1000);

        // The single repoint above can be too late (a fast first insert) or be
        // undone by later async ops (texture apply at 800ms, saved-state load).
        // Re-assert the foil channel as the active insert target early — several
        // times — and on every selection change, so even the first added object
        // lands on the foil "Effects" layer instead of the ghost "Main".
        [150, 500, 900, 1500].forEach((d) =>
          setTimeout(() => forceFoilEditContainer(), d),
        );
        editor.subscribe("SelectedItemsChanged", () =>
          forceFoilEditContainer(),
        );
      }

      try {
        if (CONFIGURATOR.ref_texture) {
          document
            .querySelector('[data-value="' + CONFIGURATOR.ref_texture + '"]')
            .classList.add("actif");
        }
      } catch (e) {
        console.log(e);
      }

      // if (preview_color && p_obj.ref_profil == "QUADRI3DVARNISH") {
      //   applyPreviewColor(preview_color);
      // }

      // check state params
      var frameParent = $j("#editorFrame").parent()[0];

      if (urlParams.get("state") == "duplicate_creation") {
        LoadMask.maskMessage(
          frameParent,
          "Duplication de votre création en cours...",
        );
        editor
          .saveProduct()
          .then(function (result) {
            saveData = result;
            currentStateId = result.stateId;
            CONFIGURATOR.ref_configuration = result.stateId;
            window.location.replace(
              "/products/" +
                configJson.product.handle +
                "?view=configurator&ref_id=" +
                currentStateId +
                "&data=" +
                encodeURIComponent(btoa(JSON.stringify(CONFIGURATOR))) +
                "&ref_profil=" +
                p_obj.ref_profil +
                "&state=creation_duplicated",
            );
          })
          .catch(function (error) {
            saveData = handleError(
              error,
              "Impossible d'enregistrer la création",
            );
          });
      }

      if (urlParams.get("state") == "creation_duplicated") {
        document.querySelector("#ccSaveButton").click();
      }
      return editor.getProduct();
    })
    .then(function (product) {
      console.log(product);
      if (mockups[product.currentSurface.name]?.length > 1) {
        editor.subscribe("ModalOpen", function () {
          disableUi(true);
        });
        editor.subscribe("ModalClose", function () {
          disableUi(false);
        });

        function _updateUi(mockupName) {
          if (mockupName == null) return;

          if (mockupName == "") mockupName = mockups[0].mockup.name;

          var index = _findMockupIndexByDataAttr(mockupName);
          if (index === -1) {
            return;
          }
          updateActiveMockupButton(index);
        }
      }
    })
    .catch(function (error) {
      console.error("Error loading product", error);
    });

  function disableUi(disable) {
    var items = document.querySelectorAll(
      ".cc-mockup-item, .cc-btn-dark, .cc-btn-make-order",
    );
    for (var i = 0; i < items.length; ++i) {
      if (disable) {
        items[i].classList.add("disabled");
      } else {
        items[i].classList.remove("disabled");
      }
    }
  }

  //Reopening the product in the designer.
  $j("#lnkEditAgain, #lnkEditAgainBottom").click(function () {
    goToPage("design");
    $j(".cd-builder-secondary-nav .nav-item.prev").hide();
    $j("#mockup-color-container").show();
    $j("#approvePage .carousel").trigger("destroy.owl.carousel");
  });

  function generateRandomString(length) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  // Ajouter le paramètre aléatoire à l'URL
  const randomString = generateRandomString(8);

  document
    .querySelector("#ccHistoryBack")
    .addEventListener("click", function () {
      window.location.href =
        "/products/" +
        configJson.product.handle +
        "?ref_profil=" +
        p_obj.ref_profil +
        "&view=" +
        randomString +
        "&page=1";
    });

  function setApprovePageData() {
    $j("#mockup-color-container").hide();
    $j(".cd-builder-secondary-nav .nav-item.prev").show();
    var previewElements = $j("#approvePage .previewImg").attr("src", "");
    for (
      var i = 0;
      i < approveData.proofImageUrls.length && i < previewElements.length;
      i++
    ) {
      previewElements[i].setAttribute("src", approveData.proofImageUrls[i]);
    }
  }

  function setDesignPageData() {}

  function goToPage(to) {
    setupPage(to);
  }

  var workflowPages = {
    design: { elements: $j("#editorPage "), setData: setDesignPageData },
    approve: { elements: $j("#approvePage"), setData: setApprovePageData },
  };

  function setupPage(page) {
    var destPageData = workflowPages[page];

    if (typeof destPageData.setData === "function") destPageData.setData();

    console.log(page, destPageData);

    if (page == "approve") {
      document.querySelector("#approvePage .carousel").innerHTML = "";
      for (var i = 0; i < mockupPreviewsImages.length; i++) {
        document.querySelector(
          "#approvePage .carousel",
        ).innerHTML += `<img src="${mockupPreviewsImages[i]}">`;
      }

      $j("#approvePage .carousel").owlCarousel({
        dots: true,
        nav: true,
        items: 1,
        navText: ["", ""],
      });

      document.querySelector("#customize").classList.add("hidden");
      document.querySelector("#approve").classList.remove("hidden");
    } else {
      document.querySelector("#customize").classList.remove("hidden");
      document.querySelector("#approve").classList.add("hidden");
      $j("#approvePage .carousel").trigger("destroy.owl.carousel");
    }

    console.log(approveData.proofImageUrls[i]);

    workflowPages[currentPage].elements.fadeOut(function () {
      destPageData.elements.show();
      currentPage = page;
    });
  }
}

if (document.querySelector("#options-color-main .items")) {
  $j(".select-color-main .group .cc-theme").css(
    "background",
    defaultEditorConfig.productThemes[defaultEditorConfig.defaultProductTheme]
      .C01,
  );
}

//keep session if the customer goes out, called each 10minutes
window.setInterval(function () {
  $j.get("https://www.1001cartes.com/configurator/index/keepsession/");
}, 600000);

jQuery(function () {
  // get creation ref on url params "ref_id"
  var urlParams = new URLSearchParams(window.location.search);
  var ref_id = urlParams.get("ref_id");

  // When returning from login (save=true), w-configurator-state.js is duplicating
  // the CC state to the customer account. Wait for it before loading the editor,
  // otherwise the editor fails to find the state (race condition).
  var waitReady =
    urlParams.get("save") === "true" && ref_id && window.__stateDuplicationDone
      ? window.__stateDuplicationDone
      : Promise.resolve();

  waitReady.then(function () {
    if (ref_id) {
      initProduct(ref_id);
      currentStateId = ref_id;
    } else {
      initProduct("");
    }
  });

  $j("body, iframe").click(function () {
    $j("#mockup-color-container .options").each(function () {
      $j(this).hide();
    });
  });

  $j("#mockup-color-container .options").click(function (event) {
    event.stopPropagation();
  });

  $j(".cc-mockup-container .select").click(function (event) {
    $j("#mockup-color-container .options").each(function () {
      $j(this).hide();
    });
    $j("#" + $j(this).data("target")).toggle();

    event.stopPropagation();
  });
});

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

async function getMockupPreview(
  data,
  type = "DynamicPreviewMockups",
  nb_previews = nb_client_mockups_preview,
  data_preview_black = null,
) {
  let images_result = [];

  // Options are resolved HERE, not only at page load: when the script first
  // runs the option drawers are not built yet, so CONFIGURATOR.current_paper
  // can still be undefined when the customer hits save. The payload then asked
  // the renderer for "Papers/undefined.jpg" and it answered HTTP 500 — which
  // this function used to swallow, leaving creations with no preview at all.
  const currentPaper =
    CONFIGURATOR.current_paper ||
    configJson.current_paper ||
    document.querySelector("[data-paper-title].actif")?.dataset.value ||
    (metafields_products.papers && metafields_products.papers.file_paper
      ? metafields_products.papers.file_paper[0]
      : null);
  if (currentPaper && !CONFIGURATOR.current_paper) {
    CONFIGURATOR.current_paper = currentPaper;
    console.warn(`[mockup] papier non résolu à l'init — repli sur ${currentPaper}`);
  }
  const currentEnveloppe =
    CONFIGURATOR.current_enveloppe ||
    document.querySelector("[data-enveloppe-title].actif")?.dataset.value ||
    null;
  const currentRibbon =
    CONFIGURATOR.current_ribbon ||
    document.querySelector("[data-ruban-title].actif")?.dataset.value ||
    null;

  console.log(data);

  document.querySelector(".loader__container")?.classList.add("visible");
  document.querySelector("media-gallery")?.classList.add("opacity");

  let pages = {
    pages: [],
  };

  for (var i = 0; i < nb_previews; i++) {
    var data2 = {
      template: `PreviewMockups/${p_obj.PreviewMockup}/${type}/${
        configJson.format.ref
      }/PREVIEW_P${i + 1}.psd`,
      format: "jpg",
      data: {},
    };

    if (type === "DynamicPreviewMockups") {
      data2["size"] = {
        width: 1000,
        height: 1000,
      };
    } else {
      data2["size"] = {
        width: 1000,
        height: 1000,
      };
    }

    for (let j = 0; j < configJson.format.ref_pages.length; j++) {
      let image = data.proofImageUrls[j][0];

      for (var k = 0; k < p_obj.design_layer_preview_mockup.length; k++) {
        console.log(p_obj.design_layer_preview_mockup[k], j);
        data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] = {
          type: "switch",
          select: `CUT${CONFIGURATOR.current_cut}`,
        };

        let quadri_3dfoil_pages = null;
        let varnish_quadri_pages = null;
        let profil = p_obj.ref_profil.toUpperCase();

        if (profil == "QUADRI3DFOIL" || profil == "3DFOIL") {
          quadri_3dfoil_pages =
            configJson.format["3d_foil_quadri_pages"].split(",");
          quadri_3dfoil_pages = quadri_3dfoil_pages.map(
            (item) => parseInt(item) - 1,
          );
        }

        if (profil == "QUADRI3DVARNISH" || profil == "3DVARNISH") {
          varnish_quadri_pages =
            configJson.format["varnish_quadri_pages"].split(",");
          varnish_quadri_pages = varnish_quadri_pages.map(
            (item) => parseInt(item) - 1,
          );
        }

        console.log(quadri_3dfoil_pages, j);

        if (
          ((p_obj.design_layer_preview_mockup[k] == "Spot1" &&
            p_obj.ref_profil != "WHITE" &&
            p_obj.ref_profil != "1COLOR" &&
            p_obj.ref_profil != "3DFOIL") ||
            (p_obj.design_layer_preview_mockup[k] == "SpotSH" &&
              p_obj.ref_profil != "3DFOIL") ||
            (p_obj.design_layer_preview_mockup[k] == "Spot2" &&
              p_obj.ref_profil != "3DVARNISH")) &&
          j > 0
        ) {
          if (
            (profil == "QUADRI3DFOIL" || profil == "3DFOIL") &&
            (p_obj.design_layer_preview_mockup[k].toUpperCase() == "SPOT1" ||
              p_obj.design_layer_preview_mockup[k].toUpperCase() == "SPOTSH") &&
            quadri_3dfoil_pages.includes(j) == false
          ) {
            data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] = {
              type: "switch",
              select: `null`,
            };
            continue;
          }

          if (
            (profil == "QUADRI3DVARNISH" || profil == "3DVARNISH") &&
            p_obj.design_layer_preview_mockup[k].toUpperCase() == "SPOT2" &&
            varnish_quadri_pages.includes(j) == false
          ) {
            data2.data[`${p_obj.design_layer_preview_mockup[k]}_P${j + 1}`] = {
              type: "switch",
              select: `null`,
            };
            continue;
          }
        }

        data2.data[
          `${p_obj.design_layer_preview_mockup[k]}_P${j + 1}\\CUT${
            CONFIGURATOR.current_cut
          }`
        ] = {
          type: "image",
          url:
            p_obj.design_layer_preview_mockup[k].toUpperCase() != "SPOTSH"
              ? image
              : image,
          // resizeMode "fill" makes the renderer cover the whole layer. Without
          // it the artwork is fitted inside and stops ~5px short of the card
          // edge, which shows as a white sliver down the left of the thumbnail
          // saved from the editor. The server-side worker that produces the
          // catalogue mockups has always sent it (libs/preview.js), which is
          // why those renders never had the defect.
          resizeMode: "fill",
        };
      }
      // Paper layer — use .jpg extension and Paper_P layer, matching ProofPreviewMockups PSD structure
      data2.data[`Paper_P${j + 1}`] = {
        type: "switch",
        select: `CUT${CONFIGURATOR.current_cut}`,
      };
      if (currentPaper) {
        data2.data[`Paper_P${j + 1}\\CUT${CONFIGURATOR.current_cut}`] = {
          type: "image",
          url: "ImagesMockups/Papers/" + currentPaper + ".jpg",
        };
      }

      data2.data[`Effect_P${j + 1}`] = {
        type: "switch",
        select: `CUT${CONFIGURATOR.current_cut}`,
      };

      data2.data[`Shadow_P${j + 1}`] = {
        type: "switch",
        select: `CUT${CONFIGURATOR.current_cut}`,
      };

      if (
        currentPaper == "350M-PB" &&
        p_obj.ref_profil.toUpperCase() == "QUADRI"
      ) {
        data2.data[`Gloss_P${j + 1}`] = {
          type: "switch",
          select: `CUT${CONFIGURATOR.current_cut}`,
        };
        data2.data[`Gloss_P${j + 1}\\CUT${CONFIGURATOR.current_cut}`] = {
          type: "image",
          url: "ImagesMockups/Effects/Gloss.png",
        };
      } else {
        data2.data[`Gloss_P${j + 1}`] = {
          type: "switch",
          select: `null`,
        };
      }
    }

    // Only ask for these layers when a value exists — "undefined.png" is a 500.
    if (currentEnveloppe) {
      data2.data[`ENVELOPE`] = {
        type: "image",
        url: `ImagesMockups/Envelopes/${currentEnveloppe}.png`,
      };
    }

    if (currentRibbon) {
      data2.data[`RIBBON`] = {
        type: "image",
        url: `ImagesMockups/Ribbons/${configJson.format.ref}/${currentRibbon}.png`,
      };
    }

    let bgs = configJson.background_preview.split(",");
    console.log(bgs);

    if (configJson.background_preview.length > 0) {
      for (const bg of bgs) {
        data2.data[bg.split(":")[0]] = {
          type: "image",
          url: `ImagesMockups/Background/${bg.split(":")[1]}`,
        };
      }
    }

    pages.pages.push(data2);
  }

  console.log("🔍 FULL API REQUEST FOR PAPER DEBUG:");
  console.log("p_obj.ref_profil:", p_obj.ref_profil);
  console.log(
    "p_obj.design_layer_preview_mockup:",
    p_obj.design_layer_preview_mockup,
  );
  console.log("CONFIGURATOR.current_paper:", CONFIGURATOR.current_paper);
  console.log("Paper layers sent:");
  for (let i = 0; i < pages.pages.length; i++) {
    console.log(
      `  Page ${i + 1}:`,
      Object.keys(pages.pages[i].data).filter(
        (k) => k.includes("Paper") || k.includes("Gloss"),
      ),
    );
  }
  console.log("Full request:", pages);

  const response = await fetch(
    window.SERVICE_URLS.di + "/api/rendering/multipage/preview",
    {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      body: JSON.stringify(pages),
    },
  );

  const result = await response.json();
  if (response.status !== 200) {
    console.error(
      `[mockup] rendu refusé (HTTP ${response.status}) — la création sera enregistrée sans vignette:`,
      result,
    );
  }
  if (response.status === 200) {
    for (let index = 0; index < result.results.length; index++) {
      let imageUrl = result.results[index].url;
      console.log("URL originale de l'API:", imageUrl);

      // Correction pour les URLs malformées de l'API
      // L'API peut renvoyer: customerscanvas.cigalo.frapi/download ou customerscanvas.cigalo/api/download
      // On veut: <hôte DI configuré>/api/download

      // Cas 1: customerscanvas.cigalo.frapi -> customerscanvas.cigalo.fr/api
      imageUrl = imageUrl.replace(
        /customerscanvas\.cigalo\.frapi/g,
        "customerscanvas.cigalo.fr/api",
      );

      // Cas 2: Remplacer tous les domaines cigalo par l'hôte DI configuré
      imageUrl = imageUrl.replace(
        /(https?:\/\/)?(customerscanvas\.cigalo\.fr|di\.customerscanvas\.cigalo\.fr|customerscanvas\.cigalo)/g,
        window.SERVICE_URLS.diHost,
      );

      // Si l'URL commence déjà par https://, on l'utilise telle quelle
      if (imageUrl.startsWith("https://")) {
        images_result.push(imageUrl);
      } else {
        images_result.push("https://" + imageUrl);
      }
      console.log("URL corrigée:", images_result[images_result.length - 1]);
    }
  }

  return images_result;
}

async function removeCut() {
  const product = await editor.getProduct();
  const mockupsData = product.surfaces.map(function (surface) {
    return { surface: surface };
  });

  // The callback used to drop setMockups' promise, so the proof could be
  // captured while the cut mockup was still being removed — that race is what
  // left a white sliver down the left edge of previews saved from the save
  // button (the order/BAT path only escaped it because an editor.saveProduct()
  // sat between the two). Await it, then give the editor a beat to repaint.
  await product.setMockups(mockupsData, { updateRevertData: false });
  await new Promise((r) => setTimeout(r, 300));
  console.log("REMOVE CUT END");
}

async function applyPreviewColor(color, container = "Main") {
  if (color) {
    await editor.getProduct().then(function (product) {
      product.surfaces.forEach((surface) => {
        let containers = surface.getContainers();
        let main = containers.find((item) => item.name == container);
        console.log(main);
        if (main) {
          main.update({
            type: "spotColor",
            previewColor: color,
            outputColor: color,
          });
        }
      });
    });
  }
}

async function applyPreviewTexture(texture) {
  if (!texture || !editor) return;
  const foilColor =
    FOIL_COLORS[texture] ||
    FOIL_COLORS[texture + ".jpg"] ||
    "rgb(218, 165, 32)";
  const textureName = texture.endsWith(".jpg") ? texture : texture + ".jpg";
  // CC auto-creates the foil container from the PSD's <CN_Effects><TFP_textures/Effects/...> marker.
  // The texture path passed to update() must match the TFP path stored in the PSD (with `textures/` prefix).
  const texturePath = "textures/Effects/" + textureName;
  try {
    const product = await editor.getProduct();
    for (const surface of product.surfaces) {
      const containers = surface.getContainers();
      // Prefer the auto-created "Effects" container (3DFOIL pattern matching Z98).
      // Fallback to "Main" for older PSDs where the foil container is named Main.
      const target =
        containers.find(
          (item) => item.name === "Effects" && "texture" in item,
        ) || containers.find((item) => item.name === "Main");
      if (!target) continue;
      if ("texture" in target) {
        await target.update({ texture: texturePath });
        console.log(
          "[applyPreviewTexture] texture update OK:",
          target.name,
          texturePath,
        );
      } else {
        await target.update({ previewColor: foilColor });
        console.log(
          "[applyPreviewTexture] spotColor fallback:",
          target.name,
          foilColor,
        );
      }
    }
  } catch (err) {
    console.error("[applyPreviewTexture] error:", err);
  }
}

// Points CC's internal "active insert" channel (userEditContainer) at the foil
// "Effects" container (fallback "Background") on the current surface. Foil/varnish
// PSDs expose no "Main" container, yet CC defaults userEditContainer to a ghost
// "Main" — so without this, new Toolbox objects (text/image/clipart) land off the
// foil layer and render transparent until the user manually clicks an existing
// foil item. Idempotent; safe to call repeatedly (on load and on selection change).
// Make user-added images behave as COVER/crop. CC 7.2.7 removed the old
// addImageAsPlaceholder flag and doesn't expose the Model constructors, so on each
// ItemAdded we convert the free ImageItem into a PlaceholderItem via the engine's
// internal "itemToPlaceholder" command (run through editor.eval), then enable cover.
// Signature verified in the editor bundle (sPolygraphy.module.js):
//   spEditor._canvasViewer.commandManager.execute("itemToPlaceholder", { item })
// wraps the ImageItem into a PlaceholderItem (swap in canvas + content = the image)
// and returns it; the command does NOT set cover, so we set isCoverMode = true after
// (⇒ contentResizeMode = Fill). Pairs with canvas.handlers.placeholderCropMode:true
// so resizing the placeholder crops/zooms instead of stretching. Defensive — it can
// only convert, never break the editor.
function enableCoverOnUserImages(editor) {
  if (
    !editor ||
    typeof editor.subscribe !== "function" ||
    typeof editor.eval !== "function"
  )
    return;
  const IApi =
    typeof CustomersCanvas !== "undefined" ? CustomersCanvas.IframeApi : null;
  const Events = IApi && IApi.Events;
  const EVENT = Events && Events.ItemAdded ? Events.ItemAdded : "ItemAdded";

  let converting = false;
  let t;
  editor.subscribe(EVENT, function () {
    if (converting) return;
    clearTimeout(t);
    t = setTimeout(convertNewImage, 150);
  });

  async function convertNewImage() {
    converting = true; // the conversion re-adds an item → mute our own ItemAdded
    try {
      const out = await editor.eval(`
        (async () => {
          try {
            const sp = globalThis.spEditor;
            const cv = sp && sp._canvasViewer;
            if (!cv) return "err:no-canvasViewer";
            const cmd = cv.commandManager || cv._commandManager ||
                        (sp.widgetsController && sp.widgetsController._commandManager);
            if (!cmd || typeof cmd.execute !== "function") return "err:no-commandManager";
            const sel = cv.selectedItems || (cv._selectionHandler && cv._selectionHandler.selectedItems);
            const img = sel && (sel._collection ? sel._collection[0] : (sel[0] || sel));
            if (!img || img.type !== "ImageItem") return "skip:" + (img && img.type);
            if (img.name === "__cover") return "skip:already-converted";
            const ph = await cmd.execute("itemToPlaceholder", { item: img });
            if (!ph) return "err:convert-returned-null";
            ph.isCoverMode = true;
            // Keep the user image as editable CONTENT, not a non-editable STUB.
            // Without this, itemToPlaceholder sometimes leaves the image as the
            // placeholder's stub (stubStorageMeta filled) → CC hides the image
            // toolbar (Retoucher/Redimensionner/Opacité). Setting isStubContent
            // = false restores the full toolbar. Confirmed via CC docs + live test.
            try { ph.isStubContent = false; } catch (e) {}
            ph.name = "__cover";
            if (typeof cv.redraw === "function") cv.redraw();
            else if (typeof cv.update === "function") cv.update();
            // Re-select so the floating toolbar recomputes its buttons with the new
            // isStubContent (it keys off selection changes). Best-effort, never fatal.
            try {
              const sh = cv._selectionHandler || cv.selectionHandler;
              if (typeof cv.clearSelection === "function") cv.clearSelection();
              else if (sh && typeof sh.clear === "function") sh.clear();
              if (typeof cv.selectItems === "function") cv.selectItems([ph]);
              else if (typeof cv.selectItem === "function") cv.selectItem(ph);
              else if (sh && typeof sh.select === "function") sh.select(ph);
            } catch (e) {}
            return "ok";
          } catch (e) {
            return "eval-err:" + (e && e.message ? e.message : String(e));
          }
        })()
      `);
      if (typeof out === "string" && /^(err|eval-err)/.test(out)) {
        console.warn("[cover]", out);
      }
    } catch (e) {
      console.warn("[cover] conversion failed (image left as-is):", e);
    } finally {
      setTimeout(function () {
        converting = false;
      }, 300);
    }
  }
}

function forceFoilEditContainer() {
  if (!editor || typeof editor.eval !== "function") return;
  editor.eval(`
    try {
      var cv = globalThis.spEditor && globalThis.spEditor._canvasViewer;
      var surf = cv && cv._surfaceHandler && cv._surfaceHandler._surface;
      if (surf) {
        var cs = surf._containers._collection;
        var foil = cs.find(function (c) { return c.name === 'Effects'; })
                || cs.find(function (c) { return c.name === 'Background'; });
        if (foil && cv.userEditContainer !== foil) cv.userEditContainer = foil;
      }
    } catch (e) {}
  `);
}

// Mark the drawer paper matching `paperValue` as the active one. Papers are
// duplicated per profil group, so scope to the current profil's group (fallback:
// the visible group, then the whole list) to avoid marking a hidden duplicate.
function setActivePaperInDrawer(paperValue) {
  if (!paperValue) return;
  const list = document.querySelector("product-drawer-papier .drawer--list");
  if (!list) return;

  const groups = list.querySelectorAll("[data-profil]");
  let scope = list;
  if (groups.length) {
    const currentProfile =
      typeof configurator !== "undefined" ? configurator.ref_profil : null;
    scope =
      [...groups].find((g) => g.dataset.profil === currentProfile) ||
      [...groups].find((g) => g.style.display !== "none") ||
      list;
  }

  const selector = '.drawer-list__item--paper[data-value="' + paperValue + '"]';
  const target = scope.querySelector(selector) || list.querySelector(selector);
  if (!target) return;

  list
    .querySelectorAll(".drawer-list__item--paper.actif")
    .forEach((p) => p.classList.remove("actif"));
  target.classList.add("actif");
}

async function applyPaperBackground() {
  if (!editor) return;

  const paperToUse = CONFIGURATOR.current_paper || configJson.current_paper;
  if (!paperToUse) return;

  // Keep the paper drawer's selection in sync with the paper actually applied to
  // the editor (covers the initial load + every paper switch), so the current
  // paper is highlighted without the user having to click it.
  setActivePaperInDrawer(paperToUse);

  const texturePath = "ImagesMockups/Papers/" + paperToUse + ".jpg";

  try {
    const product = await editor.getProduct();
    for (const [index, surface] of product.surfaces.entries()) {
      const containers =
        typeof surface.getContainers === "function"
          ? surface.getContainers()
          : [];
      const bg = containers.find((c) => c.name === "Background");
      if (!bg) continue;

      const printArea = surface.printAreas && surface.printAreas[0];

      // If container was inited as texture type (URL path), update() is same-type → works.
      try {
        await bg.update({ texture: texturePath });
      } catch (replaceErr) {
        console.warn(
          "[applyPaperBackground] update failed on surface",
          index,
          replaceErr,
        );
      }
    }
  } catch (err) {
    console.error("[applyPaperBackground] error:", err);
  }
}

/***
 *
 * NEW FUNCTIONS
 */

function applyOption() {
  editor.getProduct().then(function (product) {
    var frameParent = $j("#editorFrame").parent()[0];
    editor
      .getProofImages({ maxWidth: 1200, maxHeight: imageMaxHeight })
      .then(async function (result) {
        approveData = result;
        mockupPreviewsImages = await getMockupPreview(approveData);

        CONFIGURATOR.proofsImages = [];
        for (const img of approveData.proofImageUrls) {
          CONFIGURATOR.proofsImages.push(img[0]);
        }

        updateDataCookie();

        // CONFIGURATOR.mockupPreviewsImages = mockupPreviewsImages;
        initPrice();

        LoadMask.unmaskElement(frameParent);
      })
      .catch(function (error) {
        console.log(error);
        approveData = handleError(
          error,
          "Impossible d'enregistrer la création",
        );
        LoadMask.unmaskElement(frameParent);
      });

    document.querySelector("w-product-template").closeDrawer();
  });
}

// Update data cookie
function updateDataCookie() {
  // duplicate object configJson
  let theme = configJson.themes_colors;
  let configJsonDuplicate = JSON.parse(JSON.stringify(configJson));
  configJsonDuplicate.themes_colors = {};

  setCookie("data", JSON.stringify(configJsonDuplicate));
}

function applyCut() {
  // Build a mockup with a UNIQUE name per (cut, paper) combo to bypass any CC
  // caching of the native mockup (which would otherwise ignore an added
  // `down` slot). Layer order in CC = mockup.down (paper) → designer canvas
  // (Background container with optional custom color/image) → mockup.up (cut).
  // → user can put a custom color OVER the paper, paper still shows through
  // any transparent areas.
  return editor
    .getProduct()
    .then(function (product) {
      const currentCut =
        CONFIGURATOR.current_cut || configJson.current_cut || "00";
      const cutRef = currentCut.toString().padStart(2, "0");
      const cutRefFull = `CUT${cutRef}`;
      const cutIndex = configJson.format.ref_cut.indexOf(cutRefFull);
      const currentPaper =
        CONFIGURATOR.current_paper || configJson.current_paper;

      var mockupsData = product.surfaces.map(function (surface, index) {
        const pageNum = index + 1;
        const lookupKey = `${pageNum}-${cutIndex}`;
        const native =
          mockups[lookupKey] &&
          mockups[lookupKey][0] &&
          mockups[lookupKey][0].mockup;

        if (!native) {
          console.log(
            `Surface ${pageNum}: no native mockup found for ${cutRefFull} (key ${lookupKey})`,
          );
          return { surface: surface };
        }

        // Unique name per combo so CC builds a fresh mockup each time and picks
        // up both `up` and `down`. Reusing the native name (e.g. "mockup_1")
        // could let CC reuse a cached version that lacks the down slot.
        const synthName = currentPaper
          ? `${native.name}_p${pageNum}_c${cutIndex}_paper_${currentPaper}`
          : native.name;

        const mockupConfig = {
          surface: surface,
          mockup: {
            name: synthName,
            up: native.up,
          },
        };
        if (currentPaper) {
          mockupConfig.mockup.down = `SupportMockups/${configJson.format.ref}/${currentPaper}`;
        }
        return mockupConfig;
      });

      // setMockups is async — wrap in Promise.resolve() to catch rejections.
      // If `down` (paper mockup) path doesn't exist on CC server, CC returns 400.
      // Fallback: retry without `down` so at least the cut mockup is applied.
      const applyWithFallback = (data) => {
        return Promise.resolve(
          product.setMockups(data, { updateRevertData: false }),
        ).catch(function (error) {
          const hasDown = data.some((m) => m.mockup && m.mockup.down);
          if (hasDown) {
            console.warn(
              "setMockups with down failed (SupportMockups file missing?), retrying without down:",
              error,
            );
            const fallback = data.map((m) => {
              if (!m.mockup || !m.mockup.down) return m;
              const { down, ...rest } = m.mockup;
              return { surface: m.surface, mockup: rest };
            });
            return Promise.resolve(
              product.setMockups(fallback, { updateRevertData: false }),
            ).catch((e) =>
              console.error("Fallback setMockups also failed:", e),
            );
          }
          console.error("Error applying mockups:", error);
        });
      };
      applyWithFallback(mockupsData);
    })
    .catch(function (error) {
      console.error("Error in applyCut():", error);
    });
}

// Fonction pour appliquer uniquement le mockup de papier
async function applyPaper() {
  if (!editor) return;

  // Appeler applyCut qui gère maintenant les deux mockups
  applyCut();

  // Régénérer les images de prévisualisation pour le carousel
  try {
    const approveData = await editor.getProofImages({
      maxWidth: 1200,
      maxHeight: imageMaxHeight,
    });

    if (approveData && approveData.proofImageUrls) {
      // Générer les nouvelles images mockup avec le papier sélectionné
      const mockupImages = await getMockupPreview(approveData);
      mockupPreviewsImages = mockupImages;

      // Mettre à jour le carousel avec les nouvelles images
      if (typeof window.initMedia === "function") {
        window.initMedia(mockupImages);
      }
    }
  } catch (error) {
    console.error("Erreur lors de la régénération des previews:", error);
  }
}

//updateCreationCartItem

async function getCartItems() {
  let res = await fetch("/cart.js");
  let json = await res.json();
  return json.items;
}

async function getProduct(item) {
  let data = {
    product: _product,
    item: item,
  };

  let url =
    window.SERVICE_URLS.api + "/webhook/product?shop=" +
    encodeURIComponent(window.Shopify?.shop || "");

  let res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  let json = await res.json();
  console.log(json);
  return json.hasOwnProperty("product")
    ? json.product.variants[0].id
    : json.variant.id;
}

async function updateCreationCartItem(urlRedirect = null) {
  let item = {};

  let cartItems = await getCartItems();
  let has_item = false;
  let cartItemObj = null;

  cartItems.forEach((cartItem) => {
    if (cartItem.sku == CONFIGURATOR.ref_configuration) {
      has_item = true;
      cartItemObj = cartItem;
      item.id = cartItem.id.toString();
      item.properties = cartItem.properties;
      item.properties._preview = mockupPreviewsImages[0];
      // CONFIGURATOR has no format key — keep format.ref (needed by the
      // PDF webhook) from metafields or from the item's previous _jsconf.
      let updatedConf = { ...CONFIGURATOR };
      if (!updatedConf.format) {
        if (
          typeof metafields_products !== "undefined" &&
          metafields_products &&
          metafields_products.format &&
          metafields_products.format.ref
        ) {
          updatedConf.format = { ref: metafields_products.format.ref };
        } else {
          try {
            const prevConf = JSON.parse(atob(cartItem.properties._jsconf));
            if (prevConf.format) updatedConf.format = prevConf.format;
          } catch (e) {}
        }
      }
      item.properties._jsconf = btoa(JSON.stringify(updatedConf));
      item.properties._proofsImages = CONFIGURATOR.proofsImages;
    }
  });

  console.log(has_item);

  console.log(item);

  if (has_item) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    })
      .then(function (response) {
        return response.json();
      })
      .then(async function (data) {
        console.log(data);
        await wishlist.addCreation(item);
        const url =
          window.SERVICE_URLS.api + "/product-images";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            product_id: cartItemObj.product_id,
            images: [mockupPreviewsImages[0]],
            profil: CONFIGURATOR.ref_profil,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
        if (urlRedirect) window.location.href = urlRedirect;
      });
  } else {
    // Wishlist save already done before calling updateCreationCartItem
    if (urlRedirect) window.location.href = urlRedirect;
  }
}

// saveCreationWishlist

async function saveCreationWishlist(mockupPreviewsImages, proofsImages) {
  const jsConfData = {
    current_cut: CONFIGURATOR.current_cut,
    current_imposition: CONFIGURATOR.current_imposition,
    current_paper: CONFIGURATOR.current_paper,
    current_ribbon: CONFIGURATOR.current_ribbon,
    current_enveloppe: CONFIGURATOR.current_enveloppe,
    format_imposition: CONFIGURATOR.format_imposition,
    item_options: configJson.item_options,
    product: configJson.product,
    quantity: CONFIGURATOR.quantity,
    quantity_price: CONFIGURATOR.quantity_price,
    ref_configuration: saveData.stateId,
    ref_profil: CONFIGURATOR.ref_profil,
  };

  const proofsArray = Array.isArray(proofsImages)
    ? proofsImages
    : CONFIGURATOR.proofsImages || [];

  const item = {
    quantity: 1,
    title: configJson.product?.title || "",
    properties: {
      _ref_configuration: saveData.stateId,
      _preview: mockupPreviewsImages && mockupPreviewsImages[0],
      _price: typeof total_price !== "undefined" ? total_price : null,
      _userId:
        typeof defaultEditorConfig !== "undefined"
          ? defaultEditorConfig.userId
          : null,
      _proofsImages: JSON.stringify(proofsArray),
      _jsconf: btoa(JSON.stringify(jsConfData)),
      Quantité: CONFIGURATOR.quantity,
      Format: CONFIGURATOR.format_imposition,
      Papier: CONFIGURATOR.current_paper,
    },
  };

  return await wishlist.addCreation(item);
}

// Save creation and redirect to login form
async function redirectUserAndSaveCreation(res) {
  console.log(res);
  let ref_id_saved = res.stateId;

  // Build a relative path (Shopify return_to requires relative URLs starting with /)
  let redirectPath =
    window.location.pathname +
    "?view=configurator" +
    "&ref_id=" +
    ref_id_saved +
    "&save=true" +
    "&data=" +
    encodeURIComponent(btoa(JSON.stringify(CONFIGURATOR))) +
    "&ref_profil=" +
    p_obj.ref_profil;

  // Persist a pending wishlist payload so we can flush it into the customer
  // metafield right after login completes (see theme.liquid flush handler).
  try {
    const pendingJsConf = {
      current_cut: CONFIGURATOR.current_cut,
      current_imposition: CONFIGURATOR.current_imposition,
      current_paper: CONFIGURATOR.current_paper,
      current_ribbon: CONFIGURATOR.current_ribbon,
      current_enveloppe: CONFIGURATOR.current_enveloppe,
      format_imposition: CONFIGURATOR.format_imposition,
      item_options: configJson.item_options,
      product: configJson.product,
      quantity: CONFIGURATOR.quantity,
      quantity_price: CONFIGURATOR.quantity_price,
      ref_configuration: ref_id_saved,
      ref_profil: CONFIGURATOR.ref_profil,
    };
    const pendingItem = {
      quantity: 1,
      title: configJson.product?.title || "",
      properties: {
        _ref_configuration: ref_id_saved,
        _preview: (mockupPreviewsImages && mockupPreviewsImages[0]) || null,
        _price: typeof total_price !== "undefined" ? total_price : null,
        _userId:
          typeof defaultEditorConfig !== "undefined"
            ? defaultEditorConfig.userId
            : null,
        _proofsImages: JSON.stringify(CONFIGURATOR.proofsImages || []),
        _jsconf: btoa(JSON.stringify(pendingJsConf)),
        Quantité: CONFIGURATOR.quantity,
        Format: CONFIGURATOR.format_imposition,
        Papier: CONFIGURATOR.current_paper,
      },
    };
    sessionStorage.setItem("pendingWishlistSave", JSON.stringify(pendingItem));
  } catch (e) {
    console.error("[redirectUserAndSaveCreation] cannot store pending item", e);
  }

  // Store just the ref_id so w-configurator-state.js can duplicate the CC state
  // from the anonymous session user to the logged-in customer, without needing
  // to trigger a second redirect.
  setCookie("pending_state_duplication", ref_id_saved, 1);

  // Pass the full configurator URL as return_to so Shopify redirects the user
  // directly back to their creation — no intermediate product page.
  window.location.href =
    "/customer_authentication/login?return_to=" + encodeURIComponent(redirectPath);
}

async function saveCreationAfterRedirect() {
  let save = urlParams.get("save");
  let ref_id = urlParams.get("ref_id");
  if (save && ref_id) {
    document.querySelector("#ccSaveButton").click();
  }
}

// Exposer les fonctions globalement pour qu'elles soient accessibles depuis d'autres fichiers
window.applyCut = applyCut;
window.applyPaper = applyPaperBackground;
window.applyPaperBackground = applyPaperBackground; // Alias pour compatibilité
window.applyOption = applyOption;
window.initPaperMockups = initPaperMockups;
window.getPaperMockupPath = getPaperMockupPath;

// Auto-initialize paper mockups when papersData is available
if (typeof papersData !== "undefined" && papersData && papersData.file_paper) {
  initPaperMockups();
}
